import React, { useMemo } from 'react';
import { Joyride } from 'react-joyride';
import { useMediaQuery, useTheme } from '@mui/material';
import useTutorial from 'contexts/Tutorial';
import {
  getJoyrideOptions,
  JOYRIDE_MOBILE_FLOATING_OPTIONS,
  shouldCompleteTutorialFromJoyrideEvent,
} from 'utils/joyrideOnEvent';

const GoalsTour = () => {
  const { shouldShowTutorial, completeTutorial, activeTutorialId } = useTutorial();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const tutorialId = 'goals';

  const steps = useMemo(
    () => [
      {
        target: '[data-tour="goals-quick"]',
        content: 'Quickly track today’s goal progress at a glance. One tap will complete a goal.',
        disableBeacon: true,
      },
      {
        target: '[data-tour="goals-table-header"]',
        content: 'All of your goals live here with type and progress details.',
        placement: isMobile ? 'top' : 'bottom',
        disableBeacon: true,
      },
      {
        target: '[data-tour="goals-create"]',
        content: 'Create a goal and choose types like habit, metric, milestone, or one-time—each with its own cadence options.',
        disableBeacon: true,
      },
      {
        target: '[data-tour="goals-tabs"]',
        content: 'Switch between your goals list and the goals report.',
        disableBeacon: true,
      },
    ],
    [isMobile],
  );

  const run = shouldShowTutorial(tutorialId) || activeTutorialId === tutorialId;

  const handleEvent = (data) => {
    if (shouldCompleteTutorialFromJoyrideEvent(data)) {
      completeTutorial(tutorialId);
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      scrollToFirstStep
      options={getJoyrideOptions({ isMobile })}
      floatingOptions={isMobile ? JOYRIDE_MOBILE_FLOATING_OPTIONS : undefined}
      onEvent={handleEvent}
    />
  );
};

export default GoalsTour;
